/*!
 *
 * Copyright 2019 Dmitry Chuba
 */

const Hash = require('./hash');

jQuery(function ($) {
    'use strict';

    if (Hash.val && ['_inbox', '_sentMessages', '_messagesFromWAO'].indexOf(Hash.val) !== -1) {
        const href = $('.close-message').attr('href');
        $('.close-message').attr('href', `${href}#_${Hash.val}`);
        $(`#${Hash.val.replace(/^_/, '')}-tab`).tab('show');
    }

    // if (Hash.val && (Hash.val == 'sentMessages' || Hash.val == 'inbox')) {
    //
    // }

    if (Hash.val && Hash.val == '_composeMessage') {
        $('#composeMessage').modal('show')
    }

    $('.in-focus').focus();
    $('#composeMessage').on('hide.bs.modal', function () {
        $(this).find('#recipientName').text('');
        $(this).find('#recipientId').val('');

        $('#messagesErrorsBag').remove();
        Hash.remove();
    });

    $('[data-toggle-tab]').on('click', function () {
        $(`#${$(this).data('toggle-tab')}-tab`).tab('show');
    });

    $('[data-toggle-popup]').on('click', function () {
        const popup = $(`#${$(this).data('toggle-popup')}`);

        const to     = $(this).data('message-to');
        const toName = $(this).data('message-to-name');

        if (to && toName) {
            popup.find('#recipientName').text(toName);
            popup.find('#recipientId').val(to);
        }
        popup.modal('show');
    });

});
